export const IMAGE_TYPE = [
    { id: 0, name: 'EPI', odata: 'Epi' },
    { id: 1, name: 'Ferramenta', odata: 'Ferramenta'},
    { id: 2, name: 'Ícones', odata: 'Icone' },
    { id: 3, name: 'Dispositivo de bloqueio', odata: 'Block' },
]

export const validImageTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/x-icon'
]